﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251221    
*/
'use strict';

import { getPromise } from './ctssJQuery.js';
import { appDebugMode } from './snSite.js';

let card;
let stripe;

const clearStripeCard = () => card.clear(); 

const buildStripeCard = async (params = {}) => {

    const {
        cardElement = '#card-element',
        cardErrors = 'card-errors'
    } = params;

    try {
        const stripePublicKey = await getPromise({ url: 'Billing/PublicKey' });
        stripe = Stripe(stripePublicKey);

        const elements = stripe.elements();

        const style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element
        card = elements.create('card', { style: style });

        // Add an instance of the card Element into the `card-element` <div>
        //card.mount(params.cardElement === undefined ? '#card-element' : params.cardElement);

        card.mount(cardElement);

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', (event) => {
            //let displayError = document.getElementById(params.cardErrors === undefined ? 'card-errors' : params.cardErrors);
            let displayError = document.getElementById(cardErrors);
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });
    }
    catch (error) { }

};

const getStripeToken = async () =>
    await stripe.createToken(card).catch((e) => console.log('got error', e));


export {
    buildStripeCard,
    clearStripeCard,
    getStripeToken
}


